import gql from 'graphql-tag';

export const GET_OPERATION_ACCESSES_LIST = gql`
    query(
      $golf_group_code: String!
      $user_id: ID!
      $vue_id: String!
      $element_id: String
    ) {
      GetOperationAccessList(
        golf_group_code: $golf_group_code
        user_id: $user_id
        vue_id: $vue_id
        element_id: $element_id
    ) {
      OperationAccessList{
        user_div
        vue_id
        vue_name
        element_id
        element_name
        element_control
        display_control
      }
    }
  }
`;

export const GET_ALL_OPERATION_ACCESSES_LIST = gql`
    query(
      $golf_group_code: String
    ) {
    GetAllOperationAccessList(
        golf_group_code: $golf_group_code
    ) {
        AllOperationAccessList{
            vue_id
            system_user_div
            system_element_control
            golf_user_div
            golf_element_control
            vue_name
            element_id
            element_name
            element_control
            display_vue_name
      }
    }
  }
`;

export const UPDATE_OPERATION_ACCESSES = gql`
    mutation(
        $OperationAccessesList: [ChangeOperationAccessList]
    ){
        UpdateOperationAccesses(
            UpdateOperationAccessesList: $OperationAccessesList
        ){
            result
        }
    }
`;
